import { ref as n, inject as C } from "vue";
import { getCartSummary as i } from "../store/apis/cartCount.api-es.js";
import l from "./useCookie-es.js";
let s = "";
const u = n(0), c = n(""), { getObjectCookie: m } = l(), p = async () => {
  var o, a;
  let t = 0;
  const e = m(c.value);
  if (e) {
    const r = await i(e.CK, s);
    t = ((a = (o = r.data) == null ? void 0 : o.results) == null ? void 0 : a.length) > 0 ? r.data.results[0].itemCount : 0;
  }
  u.value = t;
}, d = (t) => {
  const { VITE_GATEWAY_API: e = "" } = C("hostEnv") || {};
  return s = e, c.value = t, {
    currentMpCartCount: u,
    updateCartCount: p
  };
};
export {
  d as default
};
//# sourceMappingURL=useMpCartCount-es.js.map
